import EventEmitter from 'src/helpers/EventEmitter'
import store from 'src/store'
import { DEG_TO_RAD } from 'src/helpers/MathUtils'

import TextureCache from 'src/helpers/TextureCache'
import FacesSpritesheet from '@/assets/sprites/faces' 
import ImageService from '@/services/ImageService'

import { TweenMax } from 'gsap'
const THREE = require('three')
import Btn from 'src/components/Stage/question/btn'
import {findWhere} from '@/helpers/ArrayUtils'

import * as dat from 'dat.gui';
  
class ResultFeedback extends THREE.Group { 

  constructor(config) {
 
    super();
  
    Object.assign(this, EventEmitter)  
   
    this.setup(); 
    this.resize() 
  }

  setup(){
 
    // let spritesheet_texture = TextureCache.getTexture(require('@/assets/sprites/faces.png'))

    this.position.z = 5;
 
    this.tweenObj = {
      distortionAmt: 0.4,
      brightness: 0.538,
      contrast: 0.221,
      saturation: 0.0,
      alpha: 1.0,
      color: '#3699d5'
    }

    let GOALS = store.state.question.GOALS;
    this.collection  = store.state.question.collection;

    this.faces = [
      new Btn({
        distortionAmt: this.tweenObj.distortionAmt,
        brightness: this.tweenObj.brightness,
        contrast: this.tweenObj.contrast,
        saturation: this.tweenObj.saturation,
        alpha: this.tweenObj.alpha,
        color: this.tweenObj.color,
        id: GOALS.ANGRY,
        complete: false,
        texture_id: require('@/assets/img/question/result/btn_angry.png')
      }),
      new Btn({
        distortionAmt: this.tweenObj.distortionAmt,
        brightness: this.tweenObj.brightness,
        contrast: this.tweenObj.contrast,
        saturation: this.tweenObj.saturation,
        alpha: this.tweenObj.alpha,
        color: this.tweenObj.color, 
        id: GOALS.SAD, 
        complete: false,
        texture_id: require('@/assets/img/question/result/btn_sad.png')
      }),
      new Btn({
        distortionAmt: this.tweenObj.distortionAmt,
        brightness: this.tweenObj.brightness,
        contrast: this.tweenObj.contrast,
        saturation: this.tweenObj.saturation,
        alpha: this.tweenObj.alpha,
        color: this.tweenObj.color, 
        id: GOALS.HAPPY, 
        complete: false,
        texture_id: require('@/assets/img/question/result/btn_happy.png')
      }),
      new Btn({
        distortionAmt: this.tweenObj.distortionAmt,
        brightness: this.tweenObj.brightness,
        contrast: this.tweenObj.contrast,
        saturation: this.tweenObj.saturation,
        alpha: this.tweenObj.alpha,
        color: this.tweenObj.color, 
        id: GOALS.CONFUSED, 
        complete: false,
        texture_id: require('@/assets/img/question/result/btn_confused.png')
      }) 
    ]
 
    for (var i = 0; i < this.faces.length; i++) { 
      let face = this.faces[i]; 
      this.add(face) 
    }

    // this.gui = new dat.GUI(); 
    // this.gui.add(this.tweenObj, 'alpha').step(0.001).min(0).max(1).onChange(this.updateOptions);
    // this.gui.add(this.tweenObj, 'distortionAmt').step(0.001).min(0).max(5.0).onChange(this.updateOptions);
    // this.gui.add(this.tweenObj, 'brightness').step(0.001).min(0).max(2.0).onChange(this.updateOptions);
    // this.gui.add(this.tweenObj, 'contrast').step(0.001).min(0).max(1.0).onChange(this.updateOptions);
    // this.gui.add(this.tweenObj, 'saturation').step(0.001).min(0).max(10.0).onChange(this.updateOptions);
    // this.gui.add(this.tweenObj, 'color').onChange(this.updateOptions);
  }

  getSortedArray(){
    return this.collection.map((goal)=>{
      return this.faces.find((face)=>{ 
        return (face.config.id === goal.id);
      })
    });
  }

  updateOptions = () => {
    for (var i = 0; i < this.faces.length; i++) {
      this.faces[i].setUniforms(this.tweenObj);
    } 
  }
 
  tick(tap_hold_ratio) { 
    // this.material.uniforms.time.value -= 0.001;
    for (var i = 0; i < this.faces.length; i++) {
      this.faces[i].tick();
    }
  }

  idle() {}

  tapholdProgress() { }
  
  tapholdRecord() {   }

  tapholdRelease() {}
    
  processing() {  }
    
  complete(val) { 

    switch(val) {
      case 0:
        this.furious();
        break;
      case 1:
        this.sad();
        break;
      case 2:
        this.angry();
        break;
      case 3:
        this.agitated();
        break;
      case 4:
        this.confused();
        break;
      case 5:
        this.mildlyamused();
        break;
      case 6:
        this.amused();
        break;
      case 7:
        this.happy();
        break;
      case 8:
        this.ecstatic();
        break;
      case 9:
        this.error();
        break;
    }
    
  }

  result(val){
  }

  furious(){  }

  sad(){ }

  angry(){ }

  agitated(){  }

  confused(){ }

  mildlyamused(){  }
  
  amused(){   }

  happy(){   }

  ecstatic(){  }
  
  error(){  }
  
  updateRoute(val) {

    if(val.name === 'question'){

      for (var i = 0; i < this.faces.length; i++) {
        let face = this.faces[i]; 
        face.hide()
      }  
     

    } else if(val.name === 'result') {
      
      let faces = this.getSortedArray();
      let initialPos = { x: 0, y: 0, z: -200 }; 
      
      this.collection.forEach((goal)=>{
        this.faces.find((face)=>{ 
          if(face.config.id === goal.id){
            face.setComplete(goal.complete);
            return;
          }
        })
      });

      faces[0].show(
        // {
        //   x: 0,
        //   y: 200,
        //   z: -200
        // },
        initialPos, {
          x: 0,
          y: 250,
          z: 0
        }, 0, 1.4);


      faces[1].show(
        // {
        //   x: 100,
        //   y: 0,
        //   z: -200
        // },
        initialPos,  {
          x: 100,
          y: 50,
          z: -100 * Math.random()
        }, 
        4 * DEG_TO_RAD, 1.6);


      faces[2].show(
        // {
        //   x: -100,
        //   y: -100,
        //   z: -200
        // },
        initialPos, { 
          x: -100,
          y: -100,
          z: -100 * Math.random()
        }, 
        -7 * DEG_TO_RAD, 1.8);


       faces[3].show(
        // {
        //   x: 100,
        //   y: -200,
        //   z: -200
        // }
        initialPos, {
          x: 100,
          y: -180,
          z: -100 * Math.random()
        }, 
        9 * DEG_TO_RAD,2);
 

    }
  }

  updateState(val){}
 
  resize() { }
 
 
}

export default ResultFeedback